export const NAME = 'mailroom';